import React, { useEffect } from 'react';
import { SiteSettings } from '../types';

interface TrackingScriptsProps {
    settings: SiteSettings;
}

const TrackingScripts: React.FC<TrackingScriptsProps> = ({ settings }) => {
    useEffect(() => {
        // Google Analytics Script Injection
        if (settings.googleAnalyticsCode) {
            const container = document.createElement('div');
            container.innerHTML = settings.googleAnalyticsCode;
            
            const scripts = container.querySelectorAll('script');
            scripts.forEach(oldScript => {
                const newScript = document.createElement('script');
                Array.from(oldScript.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                });
                newScript.innerHTML = oldScript.innerHTML;
                document.head.appendChild(newScript);
            });
        }

        // Meta Pixel Script Injection (Legacy ID support)
        if (settings.metaPixelId && !settings.googleAnalyticsCode?.includes('fbevents.js')) {
            const existingPixel = document.querySelector('script[src*="fbevents.js"]');
            if (!existingPixel) {
                const script = document.createElement('script');
                script.innerHTML = `
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '${settings.metaPixelId}');
                    fbq('track', 'PageView');
                `;
                document.head.appendChild(script);
            }
        }
        
        // Google Analytics ID Injection (Legacy ID support if code is not provided)
        if (settings.googleAnalyticsId && !settings.googleAnalyticsCode) {
            const existingGA = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
            if (!existingGA) {
                const script1 = document.createElement('script');
                script1.src = `https://www.googletagmanager.com/gtag/js?id=${settings.googleAnalyticsId}`;
                script1.async = true;
                document.head.appendChild(script1);

                const script2 = document.createElement('script');
                script2.innerHTML = `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${settings.googleAnalyticsId}');
                `;
                document.head.appendChild(script2);
            }
        }
    }, [settings.googleAnalyticsCode, settings.googleAnalyticsId, settings.metaPixelId]);

    return null;
};

export default TrackingScripts;
